import { Dispatch } from "react";
import { ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";
import { NotificationsActions, NotificationsActionTypes } from "./actionTypes";
import { INotificationsState } from "./store";
import { Notifications } from "./types";

export const clearNotificationsMessage: ActionCreator<ThunkAction<
  Promise<any>,
  INotificationsState,
  null,
  NotificationsActions
>> = () => {
  return async (dispatch: Dispatch<NotificationsActions>) => {
    dispatch({ type: NotificationsActionTypes.CLEAR_NOTIFICATION_MESSAGE });
  };
};

export const addNotificationsMessage: ActionCreator<ThunkAction<
  Promise<any>,
  INotificationsState,
  null,
  NotificationsActions
>> = (notification: Notifications) => {
  return async (dispatch: Dispatch<NotificationsActions>) => {
    dispatch({ type: NotificationsActionTypes.ADD_NOTIFICATION_MESSAGE, notification: notification });
  };
};